import Vue from 'vue'
import Router from 'vue-router'
import Learn from '@/components/views/Learn.vue'
import Quiz from '@/components/views/Quiz.vue'
import Exam from '@/components/views/Exam.vue'
import NotFound from '@/components/views/error/NotFound.vue'
import ProgramLevels from '@/components/views/ProgramLevels.vue'
import Programs from '@/components/views/Programs.vue'
import authRoutes from './auth-routes'
import guestRoutes from './guest'
import ContactSupport from '@/components/views/ContactSupport'
import Register from '@/components/views/auth/Register'

Vue.use(Router)
const app = process.env.APP_NAME

const router = new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {title: `${app}: Home`, layout: 'standard', auth: undefined}
    },
    {
      path: '/support',
      name: 'ContactSupport',
      component: ContactSupport,
      meta: {auth: true, title: `${app}: Contact Support`, heading: 'Contact support', pageTitle: 'Contact support'}
    },
    {
      path: '/programs',
      name: 'Programs',
      component: Programs,
      meta: {title: `${app}: Programs`, pageTitle: 'My Programs', auth: true, layout: 'standard'}
    },
    {
      path: '/program/:groupId/:deckId',
      name: 'ProgramLevels',
      component: ProgramLevels,
      meta: {title: `${app}: Program`, pageTitle: 'My Program', auth: true, layout: 'plain'}
    }, {
      path: '/learn/:groupId/:deckId/:level/:viewCount',
      name: 'Learn',
      component: Learn,
      meta: {title: `${app}: Learn Pane`, pageTitle: 'Learn', auth: true, layout: 'plain'}
    }, {
      path: '/quiz/:groupId/:deckId/:level/:step',
      name: 'Quiz',
      component: Quiz,
      meta: {title: `${app}: Quiz`, pageTitle: 'Quiz', auth: true, layout: 'plain'}
    }, {
      path: '/exam/:groupId/:deckId/:step',
      name: 'Exam',
      component: Exam,
      meta: {title: `${app}: Exam`, pageTitle: 'Exam', auth: true, layout: 'plain'}
    }, {
      path: '/register/:step',
      name: 'Register',
      component: Register,
      meta: {auth: true, title: `${app}: Update Profile`, pageTitle: 'Update Profile', layout: 'standard'}
    },
    ...authRoutes,
    ...guestRoutes,
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.fullPath === '/') {
    const login = localStorage.getItem('default_auth_token')
    if (login) {
      next({name: 'Programs'})
    } else {
      console.log('Login Fails in index router')
    }
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js